<div class="requestDialog">
  <div class="close-wrapper" (click)="onCancelClick()">
    <span class="req-dial-close"> Close </span>
    <cigna-icon class="close-icon" type="close"></cigna-icon>
  </div>

  <cigna-brk-statement-access-request
    [isImpersonatorFlag]="isImpersonatorFlag"
    (contactUsClickEvent)="dialogRef.close()"
  ></cigna-brk-statement-access-request>

  <div class="button-container">
    <button
      class="req-access-info-cta"
      data-test-id="button-request-access"
      *ngIf="!isImpersonatorFlag"
      mat-raised-button
      aria-label="Submit Default Client"
      cg-mat-btn-type="primary"
      (click)="onManageClick()"
      [hidden]="userPeId === ''"
    >
      {{ 'broker.compensation.requestaccess.stmtAccess' | translate }}
    </button>
    <button
      class="req-access-info-cta req-access-disabled"
      cg-mat-btn-type="primary"
      *ngIf="isImpersonatorFlag"
      mat-raised-button
      aria-label="Submit Default Client"
      [hidden]="userPeId === ''"
      disabled
    >
      {{ 'broker.compensation.requestaccess.stmtAccess' | translate }}
    </button>

    <button
      mat-dialog-close
      aria-label="Submit Default Client"
      data-test-id="btnSetDefaultClientModalSbmt"
      mat-raised-button
      class="cancel-btn"
      (click)="onCancelClick()"
    >
      {{ 'global.cancel' | translate }}
    </button>
  </div>
</div>
